const VideoControl = {
  controlElms: document.querySelectorAll('.js-videoControl'),

  init() {
    this.control();
  },

  control() {
    this.controlElms.forEach((elm) => {
      const target = elm.dataset.targetId;
      const video = document.getElementById(target);

      elm.addEventListener('click', (e) => {
        if (video.paused) {
          video.play();
          elm.classList.remove('is-paused');
        } else {
          video.pause();
          elm.classList.add('is-paused');
        }
      });
    });
  },
}

export default VideoControl;